import { createStyles, Paper, SimpleGrid } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  itemContainer: {
    borderRadius: theme.spacing.xs,
  },
  questionBox: {
    height: 40,
    width: 40,
    // marginTop: 10,
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      color: theme.white,
      backgroundColor: theme.colors.orange,
    },
  },
}));

// TODO fix types
export const ItemsProgressBox = ({ itemsToDisplay, handleClick }: any) => {
  const { classes } = useStyles();

  return (
    <Paper
      shadow="xs"
      p="sm"
      sx={(theme) => ({ borderRadius: theme.spacing.xs })}
    >
      <fieldset className={classes.itemContainer}>
        <legend>Remaining Items:</legend>
        <SimpleGrid cols={25}>
          {itemsToDisplay.map((item: any) => (
            <Paper
              key={item.number}
              className={classes.questionBox}
              shadow="xs"
              onClick={handleClick}
            >
              {item.id}
            </Paper>
          ))}
        </SimpleGrid>
      </fieldset>
    </Paper>
  );
};
